import fetch from 'libs/fetchWithAuth';
import Cookies from 'cookies';
import { apiUrl } from 'libs/apiUrl';
import { NextApiRequest, NextApiResponse } from 'next';


class Authentication {
    static async loginClient(credentials) {
        return fetch(apiUrl('/api/ext/auth/client'), { method: 'POST', body: JSON.stringify(credentials) });
    }

	static async login(login, pass, authenticatorCode = '', authenticatorSecret = '', recaptchaToken = '') {
		try {
			const json = await fetch(apiUrl('/api/ext/auth'), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ login, pass, authenticatorCode, authenticatorSecret, recaptchaToken }),
			});

			return json;
		} catch (err) {
			console.error(err);
			return {
				resp: false,
				errorCode: 'pm-credentials-invalid',
				message: 'The username or password is incorrect. Please try again.',
			};
		}
	}

	// Redeems a loginTicket returned by login() on success - see
	// api/models/Auth.php's generateLoginTicket()/loginWithTicket(). Used by
	// NextAuth's server-side authorize() callback for the PM Credentials
	// provider to finish the sign-in without calling login() (and its real
	// password check + audit-log write) a second time.
	static async loginWithTicket(ticket) {
		try {
			return await fetch(apiUrl('/api/ext/auth/ticket'), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ ticket }),
			});
		} catch (err) {
			console.error(err);
			return {
				resp: false,
				errorCode: 'pm-credentials-invalid',
				message: 'The username or password is incorrect. Please try again.',
			};
		}
	}

	static async loginWithGoogle(idToken, companyId, role, avatarUrl) {
		try {
			return await fetch(apiUrl('/api/ext/auth/google'), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ idToken, companyId, role, avatarUrl }),
			});
		} catch (err) {
			console.error(err);
			return {
				resp: false,
				errorCode: 'google-sign-in-failed',
			};
		}
	}

	static async getTokenForPublicUrl(hash, req, res) {
		try {
			const json = await fetch(
				apiUrl('/api/ext/auth-by-hash'),
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ hash }),
				}
			);

			if (!json?.resp?.token) return null;

			const isSecureContext = Boolean(
				(process.env.NEXT_PUBLIC_FRONTEND_URL ||
					process.env.FRONTEND_URL ||
					'').startsWith('https://')
			);
			const cookieSameSite = isSecureContext ? 'none' : 'lax';

			const token = json.resp.token;
			const cookies = new Cookies(req, res);
			cookies.set('next-auth.session-token', token, {
				httpOnly: false,
				sameSite: cookieSameSite,
				secure: isSecureContext,
				path: '/',
			});

			try {
				cookies.set('__Secure-next-auth.session-token', token, {
					httpOnly: false,
					sameSite: 'none',
					secure: true,
					path: '/',
				});
			} catch (error) {
				console.log('errnoo', error)
			}


			const newReq = {
				...req,
				headers: {
					...req.headers,
					Authorization: `Bearer ${token}`,
				},
			};

			return newReq;
		} catch (err) {
			console.log('errno', err);
			return null;
		}
	}

	static async getTokenForPublicUrlByHash(hash, req, res) {
		if (req && res) {
			return this.getTokenForPublicUrl(hash, req, res);
		}

		try {
			const json = await fetch(
				apiUrl('/api/ext/auth-by-hash'),
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ hash }),
				}
			);

			console.log('jsonn', json, hash);

			if (!json?.resp) return json;
			return json;
		} catch (err) {
			console.log(err);
			return {
				resp: false,
				errorCode: 'task-not-found',
				message: 'Please sign in to your dashboard to see your current tasks.',
			};
		}
	}

	// Fire-and-forget audit log entry - called from immediateSignOut() while
	// the auth cookie is still present, before it gets cleared. Sign-out
	// itself doesn't depend on this succeeding.
	static async logout() {
		try {
			return await fetch(apiUrl('/api/ext/logout'), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
			});
		} catch (err) {
			console.error(err);
			return null;
		}
	}

	static checkForExistingToken(req) {
		return fetch(apiUrl('/api/ext/check-for-existing-token'), {}, req);
	}

	static async getTokenForCode(body) {

		try {
			const json = await fetch(
				apiUrl('/api/ext/auth-by-code'),
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ body }),
				}
			);
			console.log('json', json);

			if (!json?.resp) {
				return json;
			}

			if (!json?.resp?.token) {
				return null;
			}

			const token = json.resp.token;

			return json;
		} catch (err) {
			console.log(err);
			return {
				resp: false,
				errorCode: 'otp-is-invalid',
				message: 'The one-time password is invalid or has expired. Please request a new code and try again.',
			};
		}
	}

	static async getTokenForTranslator(body) {
		try {
			const endpoint = body?.password ? '/api/ext/auth-by-password' : '/api/ext/auth-by-code';
			const json = await fetch(
				apiUrl(endpoint),
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ body }),
				}
			);

			return json;
		} catch (err) {
			console.log(err);
			return {
				resp: false,
				errorCode: body?.password ? 'email-or-password-is-wrong' : 'otp-is-invalid',
				message: body?.password
					? 'The email or password is incorrect. Please try again.'
					: 'The one-time password is invalid or has expired. Please request a new code and try again.',
			};
		}
	}

	static setCookie(name, value, days) {
		const expirationDate = new Date();
		expirationDate.setDate(expirationDate.getDate() + days);

		const cookieString = `${name}=${encodeURIComponent(value)}; expires=${expirationDate.toUTCString()}; path=/`;

		document.cookie = cookieString;
	}
}

export default Authentication;
